var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame2147207307(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_9747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.20312 4.46875V13H4.07227V4.46875H5.20312ZM14.5723 4.46875V13H13.4355L9.14062 6.41992V13H8.00977V4.46875H9.14062L13.4531 11.0664V4.46875H14.5723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14.1719H15.5801V14.7578H3V14.1719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.instagram.com/asraimmigration?igsh=MXIxNjdkenZwbWY0aQ=="
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    y: 1.96875,
    width: 12.5801,
    height: 14.0625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_9747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 -0.00195312H4.21875C1.8888 -0.00195312 0 1.88685 0 4.2168V13.7793C0 16.1092 1.8888 17.998 4.21875 17.998H13.7812C16.1112 17.998 18 16.1092 18 13.7793V4.2168C18 1.88685 16.1112 -0.00195312 13.7812 -0.00195312Z",
    fill: "url(#paint0_radial_3432_9747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 -0.00195312H4.21875C1.8888 -0.00195312 0 1.88685 0 4.2168V13.7793C0 16.1092 1.8888 17.998 4.21875 17.998H13.7812C16.1112 17.998 18 16.1092 18 13.7793V4.2168C18 1.88685 16.1112 -0.00195312 13.7812 -0.00195312Z",
    fill: "url(#paint1_radial_3432_9747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00063 1.9668C7.09109 1.9668 6.85139 1.97516 6.10144 2.00927C5.35289 2.04358 4.84193 2.16205 4.39488 2.33594C3.93237 2.51552 3.54009 2.75577 3.1493 3.14671C2.75815 3.53758 2.51789 3.92985 2.33775 4.39216C2.16338 4.83934 2.04476 5.35052 2.01108 6.09871C1.97754 6.84873 1.96875 7.0885 1.96875 8.99812C1.96875 10.9077 1.97719 11.1467 2.01122 11.8966C2.04567 12.6452 2.16415 13.1561 2.33789 13.6032C2.51761 14.0657 2.75787 14.458 3.1488 14.8488C3.53953 15.2399 3.9318 15.4807 4.39397 15.6603C4.84137 15.8342 5.3524 15.9527 6.1008 15.987C6.85083 16.0211 7.09031 16.0294 8.99979 16.0294C10.9095 16.0294 11.1485 16.0211 11.8984 15.987C12.647 15.9527 13.1585 15.8342 13.6059 15.6603C14.0682 15.4807 14.4599 15.2399 14.8506 14.8488C15.2417 14.458 15.4819 14.0657 15.6621 13.6034C15.8349 13.1561 15.9536 12.645 15.9888 11.8967C16.0225 11.1468 16.0312 10.9077 16.0312 8.99812C16.0312 7.0885 16.0225 6.84888 15.9888 6.09885C15.9536 5.3503 15.8349 4.83941 15.6621 4.39237C15.4819 3.92985 15.2417 3.53758 14.8506 3.14671C14.4595 2.75563 14.0683 2.51537 13.6055 2.33601C13.1572 2.16205 12.646 2.04351 11.8974 2.00927C11.1474 1.97516 10.9086 1.9668 8.99845 1.9668H9.00063ZM8.36986 3.2339C8.5571 3.23362 8.766 3.2339 9.00063 3.2339C10.878 3.2339 11.1005 3.24065 11.8419 3.27433C12.5274 3.30569 12.8995 3.42023 13.1474 3.51648C13.4755 3.64389 13.7095 3.79626 13.9554 4.04242C14.2015 4.28852 14.3538 4.52287 14.4816 4.85102C14.5778 5.09852 14.6925 5.47061 14.7237 6.15616C14.7574 6.89739 14.7647 7.12 14.7647 8.9965C14.7647 10.873 14.7574 11.0957 14.7237 11.8368C14.6924 12.5224 14.5778 12.8945 14.4816 13.1421C14.3542 13.4702 14.2015 13.7039 13.9554 13.9498C13.7093 14.1959 13.4757 14.3482 13.1474 14.4757C12.8998 14.5724 12.5274 14.6866 11.8419 14.718C11.1007 14.7516 10.878 14.759 9.00063 14.759C7.12315 14.759 6.90061 14.7516 6.15945 14.718C5.4739 14.6863 5.1018 14.5718 4.85374 14.4755C4.52566 14.3481 4.29124 14.1958 4.04515 13.9497C3.79905 13.7036 3.64676 13.4698 3.519 13.1415C3.42274 12.8939 3.30806 12.5218 3.27684 11.8363C3.24316 11.095 3.23641 10.8724 3.23641 8.99474C3.23641 7.11705 3.24316 6.89563 3.27684 6.1544C3.3082 5.46885 3.42274 5.09676 3.519 4.84891C3.64648 4.52076 3.79905 4.28641 4.04522 4.04031C4.29138 3.79422 4.52566 3.64185 4.85381 3.51416C5.10166 3.41748 5.4739 3.30323 6.15945 3.27173C6.80808 3.24241 7.05945 3.23362 8.36986 3.23214V3.2339ZM12.7539 4.40137C12.2881 4.40137 11.9102 4.77895 11.9102 5.24484C11.9102 5.71066 12.2881 6.08859 12.7539 6.08859C13.2197 6.08859 13.5977 5.71066 13.5977 5.24484C13.5977 4.77902 13.2197 4.40109 12.7539 4.40109V4.40137ZM9.00063 5.38722C7.00657 5.38722 5.3898 7.00398 5.3898 8.99812C5.3898 10.9923 7.00657 12.6082 9.00063 12.6082C10.9948 12.6082 12.611 10.9923 12.611 8.99812C12.611 7.00406 10.9946 5.38722 9.00049 5.38722H9.00063ZM9.00063 6.65432C10.295 6.65432 11.3444 7.70359 11.3444 8.99812C11.3444 10.2925 10.295 11.3419 9.00063 11.3419C7.70625 11.3419 6.65691 10.2925 6.65691 8.99812C6.65691 7.70359 7.70618 6.65432 9.00063 6.65432Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3432_9747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.78125 19.3844) rotate(-90) scale(17.8393 16.592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3432_9747",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.01507 1.29468) rotate(78.681) scale(7.97428 32.8702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_9747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_9747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2147207307);
export default __webpack_public_path__ + "static/media/Frame 2147207307.7f1716f0dd31f344cb6513d6a605da45.svg";
export { ForwardRef as ReactComponent };